import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import './Resources.scss';
import foundryImage from '../../../images/foundry1_min.jpg';

const Resources = () => {

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const resourceItems = [
    {
      title: 'CAGE Code Registration',
      description: "You don't need a CAGE code to engage with ICON but to secure a government defense contract you must have a current registered CAGE code.",
      link: 'https://www.sam.gov',
      linkText: 'Visit SAM.gov',
      details: "If you don't have a current CAGE, ICON will generate a random number code to grant access to the platform that can be updated later in the supplier profile.",
      icon: 'fa-id-card'
    },
    {
      title: 'DIBBS Registration',
      description: 'Register with the DLA Internet Bid Board System - DIBBS registration provides ICON users with access to Technical Data Packages (drawings and prints) and connections to bid on the solicitations offered through ICON.',
      link: 'https://www.dibbs.bsm.dla.mil/dodwarning.aspx?goto=/register/',
      linkText: 'Register for DIBBS',
      details: 'Access to technical drawings and print specifications for government contracts.',
      icon: 'fa-database'
    },
    {
      title: 'Joint Certification Program (JCP)',
      description: 'JCP registration allows US and Canadian entities to access unclassified military technical data and provides manufacturers the opportunity to access those technical data packages.',
      link: 'https://www.dla.mil/Logistics-Operations/Services/JCP/',
      linkText: 'Visit JCP Home',
      details: 'Access unclassified military technical data for manufacturing opportunities.',
      icon: 'fa-certificate'
    }
  ];

  return (
    <Container fluid className="p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Resources</title>
        <meta name="description" content="Essential resources to maximize your success with ICON for government contract bidding" />
      </Helmet>

      {/* Hero Banner */}
      <div className="resources-hero">
        <div className="resources-hero-background" style={{ backgroundImage: `url(${foundryImage})` }} />
        <Container>
          <div className="resources-hero-content">
            <div className="resources-icon">
              <i className="fa fa-graduation-cap" />
            </div>
            <h1>Resources</h1>
            <p className="lead">
              Maximize the value of ICON for research and ultimately submit successful bids to government projects.
              Certain registrations and certifications must be achieved.
            </p>
          </div>
        </Container>
      </div>

      <Container className="resources-page">
        {/* Introduction Section */}
        <Row className="mb-5">
          <Col lg={8} className="mx-auto">
            <div className="resources-intro">
              <h2>Getting Started with Government Contracting</h2>
              <p>
                To maximize your success with ICON and effectively bid on government defense contracts,
                you will need to complete several important registrations and certifications. These requirements
                ensure you have the proper credentials and access to compete for government opportunities.
              </p>
            </div>
          </Col>
        </Row>
        {/* Resource Cards */}
        <Row className="resources-cards-container">
          {resourceItems.map((item) => (
            <Col md={6} lg={4} key={item.title} className="mb-4">
              <Card className="h-100 resource-card">
                <CardBody>
                  <div className="resource-icon-container">
                    <i className={`fa ${item.icon}`} />
                  </div>
                  <CardTitle tag="h3">{item.title}</CardTitle>
                  <p className="resource-description">{item.description}</p>
                  {item.details && (
                    <p className="resource-details">{item.details}</p>
                  )}
                  <div className="resource-action">
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="resource-button"
                    >
                      {item.linkText}
                    </a>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Additional Information */}
        <Row className="mt-5">
          <Col lg={10} className="mx-auto">
            <Card className="resources-info-card">
              <CardBody>
                <h3>Important Notes</h3>
                <ul className="resources-checklist">
                  <li>
                    <i className="fa fa-check-circle text-success" />
                    <strong>CAGE Code:</strong> While not required for ICON access, you must have a registered CAGE code to secure defense contracts
                  </li>
                  <li>
                    <i className="fa fa-check-circle text-success" />
                    <strong>DIBBS Access:</strong> Essential for accessing technical data packages and bidding on solicitations
                  </li>
                  <li>
                    <i className="fa fa-check-circle text-success" />
                    <strong>JCP Certification:</strong> Required for accessing unclassified military technical data
                  </li>
                  <li>
                    <i className="fa fa-info-circle text-info" />
                    <strong>Timeline:</strong> Allow adequate time for registration approvals before pursuing contracts
                  </li>
                </ul>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Help Section */}
        <div className="resources-help mt-5 mb-4">
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h3>Need Assistance with Registration?</h3>
              <p>Our support team can help guide you through the registration process and answer questions about government contracting requirements.</p>

              <div className="contact-info-container">
                <div className="contact-person">
                  <p className="contact-name">ICON SUPPORT TEAM</p>
                  <p className="contact-org">Non-Ferrous Founders&#39; Society</p>

                  <div className="contact-details">
                    <p><strong>Phone:</strong> <a href="tel:8472990876">(847) 299-0876</a></p>
                    <p><strong>Email:</strong> <a href="mailto:support@iconportal.com">support@iconportal.com</a></p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
};

export default Resources;



// WEBPACK FOOTER //
// ./src/pages/static/Resources/Resources.jsx